import './BasicInput.scss';

const BasicInput = (props: {
  placeholder: string;
  text: string;
  mono?: boolean;
  password?: boolean;
  error?: boolean;
  onTextChanged: (text: string) => void;
  onSubmit?: () => void;
}) => {
  return (
    <input type={ props.password ? 'password' : 'text' }
      className={ `basic-input${ props.mono ? ' mono' : '' }${ props.error ? ' error' : '' }` }
      placeholder={ props.placeholder }
      value={ props.text } onChange={ (event) => {
        props.onTextChanged(event.target.value);
      } } onKeyDown={ (event) => {
        if (event.keyCode === 13 && !!props.onSubmit) {
          event.preventDefault(); props.onSubmit();
        }
      } } autoComplete="off" />
  );
};

export default BasicInput;
